import { number, object, string } from 'yup';
import i18n from '../../../i18n';
import {
  Damages,
  Vehicle,
} from '../../../pages/main/workOrders/AddVehicle/types';

export const VehicleSchema = object<Vehicle>({
  colorVehicle: string().required(() => i18n.t('validation:required')),
  insurerVehicle: string().required(() => i18n.t('validation:required')),
  modelVehicle: string().required(() => i18n.t('validation:required')),
  occupantsVehicle: number().required(() => i18n.t('validation:required')),
  policyVehicle: string().required(() => i18n.t('validation:required')),
  registVehicle: string().required(() => i18n.t('validation:required')),
});

export const DamagesSchema = object<Damages>({
  damages: string().when(
    '$damagesSwitchState',
    ([damagesSwitchState], schema) =>
      damagesSwitchState
        ? schema.required(() => i18n.t('validation:required'))
        : schema.notRequired()
  ),
});
